import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=868b8e3a&scoped=true&lang=pug&"
import script from "./AccountSetup.vue?vue&type=script&lang=ts&"
export * from "./AccountSetup.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSetup.vue?vue&type=style&index=0&id=868b8e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868b8e3a",
  null
  
)

export default component.exports